import { Loader2, MessageCircle, Phone } from 'lucide-react';
import { CUSTOMER_CARE_TEL } from '@/shared/constants/contact';
import { useFreshchatReady } from '@/shared/hooks/useFreshchatReady';
import { cn } from '@/shared/utils/cn';

const CONTACT_BUTTON_CLASS =
  'flex h-[53px] flex-1 items-center justify-center rounded border border-[#e2e2e2] bg-white px-2.5 text-sm text-black shadow-[0_1px_4px_rgba(0,0,0,0.06)]';

export function CallAndChat({ onContactClick }: { onContactClick?: (contactType: 'Call' | 'Chat') => void }) {
  const isChatLoading = useFreshchatReady();

  const handleChat = () => {
    if (isChatLoading) return;
    onContactClick?.('Chat');

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('freshchat:open'));
    }
  };

  return (
    <div className="flex gap-[15px] p-[15px]">
      <div className={CONTACT_BUTTON_CLASS}>
        <a
          href={CUSTOMER_CARE_TEL}
          className="flex items-center justify-center gap-1.5 text-black"
          onClick={() => onContactClick?.('Call')}
        >
          <Phone className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden />
          <span>
            Call&nbsp;us&nbsp;
            <span className="text-xs max-[359px]:hidden">(Toll&nbsp;Free)</span>
          </span>
        </a>
      </div>

      <button
        type="button"
        onClick={handleChat}
        disabled={isChatLoading}
        aria-label={isChatLoading ? 'Loading chat' : 'Chat with us'}
        className={cn(CONTACT_BUTTON_CLASS, 'cursor-pointer hover:bg-gray-50 disabled:cursor-default')}
      >
        {isChatLoading ? (
          <Loader2 className="h-8 w-8 animate-spin text-[#6b8fb8]" aria-hidden />
        ) : (
          <span className="flex items-center justify-center gap-1.5">
            <MessageCircle className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden />
            Chat&nbsp;with&nbsp;us
          </span>
        )}
      </button>
    </div>
  );
}
